import classes from "../SeedLister.module.css"
import { useTranslation } from "react-i18next"

const GachaInit = props => {
    const { t } = useTranslation()

    return (
        <div className={classes.Wrapper}>
            <h2>{t("misc:SeedListing.SeedFinder")}</h2>
            <p>{t("misc:SeedListing.Intro")}</p>
        </div>
    )
}

export default GachaInit
